export function getBlockUrl(bareUrl: string, version?: string): string {
    return version ? bareUrl + '@' + version.toLowerCase().replace(/[^\w\d]|\s/, '') : bareUrl;
}

export function name2url(name?: string): string | undefined {
    return name?.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase();
}
